import { FunctionComponent } from 'react';
import { Grid } from 'ui';
import { IconPerson } from '@tock/icons';
import { SlimPatron, getFullName } from '@tock/shared/utils/patron';
import { Typography, TypographyProps } from 'omakase';
import Anchor from 'components/Anchor';
import HideFromIOSNativeApp from 'components/ui/HideFromIOSNativeApp';
import IconBlank from 'components/icons/svgr/IconBlank';

export interface ReservationDinerAndOwnerDetailProps {
  inVisitEdit: boolean;
  onSwitchAccounts?(): void;
  purchaseDiner?: SlimPatron & { id: number };
  purchaseOwner?: SlimPatron & { id: number };
  typographyVariant?: TypographyProps['variant'];
}

export const ReservationDinerAndOwnerDetail: FunctionComponent<
  ReservationDinerAndOwnerDetailProps
> = ({
  inVisitEdit,
  onSwitchAccounts,
  purchaseDiner,
  purchaseOwner,
  typographyVariant = 'body02',
}) => {
  return (
    <>
      <li>
        <Grid container>
          <Grid container alignItems="center" item xs={12}>
            <IconPerson />
            {purchaseOwner &&
            purchaseDiner &&
            purchaseOwner.id !== purchaseDiner.id &&
            !inVisitEdit ? (
              <Typography
                component="span"
                variant={typographyVariant}
                color="fgDefault"
                data-testid="booked-by-info"
              >
                {`${getFullName(purchaseDiner)} booked by ${getFullName(purchaseOwner)}`}
              </Typography>
            ) : (
              <Typography variant={typographyVariant} color="fgDefault">
                {getFullName(purchaseOwner)}
              </Typography>
            )}
          </Grid>

          {onSwitchAccounts && purchaseOwner && (
            <Grid container alignItems="center" item xs={12}>
              <IconBlank />
              <Typography component="span" variant="caption" color="fgSubtle">
                {`${purchaseOwner.email}  `}
                <HideFromIOSNativeApp>
                  <Anchor onClick={onSwitchAccounts} className="Receipt-switchAccount">
                    Switch&nbsp;account
                  </Anchor>
                </HideFromIOSNativeApp>
              </Typography>
            </Grid>
          )}
        </Grid>
      </li>
    </>
  );
};
